const groupByForWidget = (config) => {
  if (!config) {
    return [];
  }
  const rowPivots = config.rowPivots.map((pivot) => ({ type: "row", fields: pivot.fields }));
  const columnPivots = config.columnPivots.map((pivot) => ({ type: "column", fields: pivot.fields }));
  return [...rowPivots, ...columnPivots];
};
const metricsForWidget = (config) => {
  if (!config) {
    return [];
  }
  return config.series.map((series) => ({ function: series.function, name: series.effectiveName }));
};
const createWidgetSummaryRequest = (view, widget, widgetResult) => {
  var _a, _b, _c, _d;
  const widgetTitle = view.getWidgetTitleByWidget(widget);
  const headers = (_b = (_a = widgetResult == null ? void 0 : widgetResult.chart) == null ? void 0 : _a.column_names) != null ? _b : [];
  const rows = ((_d = (_c = widgetResult == null ? void 0 : widgetResult.chart) == null ? void 0 : _c.rows) != null ? _d : []).filter((r) => r.source === "leaf").flatMap((r) => r.values.map((subRow) => [[...r.key, ...subRow.key].join("."), subRow.value]));
  return {
    type: "widget",
    payload: {
      name: widgetTitle,
      description: widget.description,
      context: widget.context,
      config: {
        type: "aggregation",
        group_by: groupByForWidget(widget.config),
        metrics: metricsForWidget(widget.config)
      },
      data: {
        headers,
        rows
      }
    }
  };
};
export default createWidgetSummaryRequest;
